import emailValidator from "email-validator";
import cardValidator from "card-validator";

function isValidPhoneNumber(countryCode, phoneNumber) {
  if (countryCode === "0057" && phoneNumber.length === 10) {
    return true;
  } else if (countryCode === "00591" && phoneNumber.length === 8) {
    return true;
  } else if (countryCode === "00385" && phoneNumber.length === 9) {
    return true;
  } else return false;
}

function isValidCode(code) {
  const re = /^[0-9]{4}$/;
  return re.test(code);
}

function isValidPin(code) {
  const re = /^[0-9]{5}$/;
  return re.test(code);
}

function isValidEmail(email) {
  return emailValidator.validate(email);
}

function isValidExpirationMonth(value) {
  const month = parseInt(value, 10);

  if (month) {
    return month > 0 && month <= 12;
  } else return false;
}

function isValidExpirationYear(value) {
  const year = parseInt(value, 10);
  const currentYear = new Date()
    .getFullYear()
    .toString()
    .substr(-2);

  if (year) {
    return year >= currentYear && year <= 99;
  } else return false;
}

function isValidCCV(value) {
  /* CCV can be 3 or 4 digits */
  const re = /^[0-9]{3,4}$/;
  return re.test(value);
}

function isValidCreditCardNumber(value) {
  return cardValidator.number(value).isValid;
}

export default {
  isValidPhoneNumber,
  isValidCode,
  isValidPin,
  isValidEmail,
  isValidCreditCardNumber,
  isValidExpirationMonth,
  isValidExpirationYear,
  isValidCCV
};



// WEBPACK FOOTER //
// ./src/Validators/Validators.js